const buildVersion = "23.3.0"
const buildId = "1.5.5-36ce184"

export { buildId, buildVersion }
